module.exports = __webpack_public_path__ + "img/icon-6.9b614adf.svg";